import I18n from 'I18n';
import Products from 'merchandise-lib/constants/Product';
export const getHubAndTierFromApiName = apiName => {
  const hub = apiName === null || apiName === void 0 ? void 0 : apiName.split('-')[0];
  const tier = apiName === null || apiName === void 0 ? void 0 : apiName.split('-')[2];
  return {
    hub: hub === 'crm' ? 'suite' : hub,
    tier: !tier && hub === 'hubspot' ? 'free' : tier // free tools api name has no tier
  };
};
export const isCommerceHub = hub => {
  return hub === 'commerce-hub';
};
export const TIER_DOWNGRADES = {
  [Products.MARKETING_HUB_PROFESSIONAL]: Products.MARKETING_HUB_STARTER,
  [Products.MARKETING_HUB_ENTERPRISE]: Products.MARKETING_HUB_PROFESSIONAL,
  [Products.SALES_HUB_PROFESSIONAL]: Products.SALES_HUB_STARTER,
  [Products.SALES_HUB_ENTERPRISE]: Products.SALES_HUB_PROFESSIONAL,
  [Products.SERVICE_HUB_PROFESSIONAL]: Products.SERVICE_HUB_STARTER,
  [Products.SERVICE_HUB_ENTERPRISE]: Products.SERVICE_HUB_PROFESSIONAL,
  [Products.CMS_HUB_PROFESSIONAL]: Products.CMS_HUB_STARTER,
  [Products.CMS_HUB_ENTERPRISE]: Products.CMS_HUB_PROFESSIONAL,
  [Products.OPERATIONS_HUB_PROFESSIONAL]: Products.OPERATIONS_HUB_STARTER,
  [Products.OPERATIONS_HUB_ENTERPRISE]: Products.OPERATIONS_HUB_PROFESSIONAL,
  [Products.COMMERCE_HUB_ENTERPRISE]: Products.COMMERCE_HUB_PROFESSIONAL
};
export const getLowerTierProduct = apiName => {
  if (apiName === Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL) {
    return I18n.text(`purchaseMotions.products.hubspotStarter`);
  } else if (apiName === Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE) {
    return I18n.text(`purchaseMotions.products.hubspotProfessional`);
  }
  const lowerTierApiName = TIER_DOWNGRADES[apiName];
  if (!lowerTierApiName) {
    return null;
  }
  return I18n.text(`purchaseMotions.products.${lowerTierApiName}`);
};